import { Component } from '@angular/core';
import { NavParams, Platform } from '@ionic/angular';

import { AuthService } from '../../service/auth.service';
import { EventService } from '../../service/event.service';

@Component({
    selector: 'app-bulkmenu-modal',
    templateUrl: './bulkmenu-modal.page.html',
    styleUrls: ['./bulkmenu-modal.page.scss'],
})
export class BulkmenuModalPage
{
    private obj: any;

    constructor(
        private navParams: NavParams,
        private platform: Platform,
        private auth: AuthService,
        private event: EventService
    )
    {
    }

    async ngOnInit()
    {
        this.event.modal_subject.next({key: "modalSubscribe", id: 'bulkmenu-modal', value: null});
        this.obj = this.navParams.data.obj;
    }

    async bulkmenuClose()
    {
        this.event.modal_subject.next({key: "closeModal", id: 'bulkmenu-modal', value: null});
    }
}
